import React from 'react';

const MintPillowLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    role="img"
    data-testid="mintPillowLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <rect
      id="Artboard1"
      x="0"
      y="0"
      width="200"
      height="50"
      style={{ fill: 'none' }}
    />
    <g id="Artboard11">
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M96.53,0L117.37,0L128.16,13.65L138.59,0L158.83,0L158.83,54.28L136.49,54.28L136.49,27.82L136.34,27.82L126.67,40.56L116.77,27.82L116.62,27.82L116.62,54.28L96.53,54.28L96.53,0Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <rect
          x="165.05"
          y="0"
          width="22.34"
          height="54.28"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <rect
          x="0"
          y="0"
          width="90.45"
          height="54.28"
          style={{ fill: 'rgb(121,220,186)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M193.61,0L213.93,0L229.9,23.17L230.05,23.09L230.05,0L250.14,0L250.14,54.28L229.83,54.28L213.86,31.11L213.71,31.19L213.71,54.28L193.62,54.28L193.62,0L193.61,0Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M270.76,18.45L255.61,18.45L255.61,0L308.24,0L308.24,18.44L293.1,18.44L293.1,54.27L270.76,54.27L270.76,18.45Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M0,59.35L20.54,59.35C33.58,59.35 48.2,63.1 48.2,78.62C48.2,92.57 36.51,98.19 23.09,98.19L22.34,98.19L22.34,113.63L0,113.63L0,59.35ZM22.94,84.39C26.77,84.39 28.56,82.36 28.56,79.81C28.56,77.26 26.68,75.24 22.94,75.24L22.34,75.24L22.34,84.39L22.94,84.39Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <rect
          x="52.62"
          y="59.35"
          width="22.34"
          height="54.28"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M81.18,59.35L103.52,59.35L103.52,94.36L120.31,94.36L120.31,113.63L81.18,113.63L81.18,59.35Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M125.78,59.35L148.12,59.35L148.12,94.36L164.91,94.36L164.91,113.63L125.78,113.63L125.78,59.35Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M227.44,59.35L251.28,59.35L256.68,84.54L256.83,84.54L261.41,59.35L276.48,59.35L280.98,84.54L281.13,84.54L286.6,59.35L308.19,59.35L292.22,113.63L272.5,113.63L267.85,92.49L267.7,92.49L263.13,113.63L243.34,113.63L227.45,59.35L227.44,59.35Z"
          style={{ fill: 'rgb(25,25,25)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.389307,0,0,0.389307,40,2.72385)">
        <path
          d="M198.35,58.52C181.33,58.52 168.06,70.74 168.06,86.48C168.06,102.22 181.33,114.44 198.35,114.44C215.37,114.44 228.64,102.22 228.64,86.48C228.64,70.74 215.37,58.52 198.35,58.52Z"
          style={{ fill: 'rgb(3,179,128)', fillRule: 'nonzero' }}
        />
      </g>
    </g>
  </svg>
);

export default MintPillowLogo;
